export default __webpack_public_path__ + "static/media/two-eyes.bce3dc37.md";